import { Injectable, Injector, inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import { createOidc } from 'oidc-spa/core';
import { EnvironmentService } from '../services/environment.service';
import { AuthKeycloakService } from '../services/auth-keycloak.service';
import { AuthCartoAfService } from '../services/auth-cartoaf.service';
import { AuthOidcService } from '../services/auth-oidc.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInitService {

  service: any;

  private readonly environmentService = inject(EnvironmentService);
  private readonly injector = inject(Injector);
  private readonly keycloak = inject(Keycloak, { optional: true });

  init(): Promise<boolean> {
    const env = this.environmentService.environment;

    switch (env.auth_provider) {
      case 'keycloak':
        this.service = this.injector.get(AuthKeycloakService);
        return this.keycloak!.init({
          responseMode: 'query',
          onLoad: env.keycloak!.onLoad ?? 'login-required',
          checkLoginIframe: false,
        }).then(authenticated => {
          if (authenticated) {
            return this.keycloak!.loadUserProfile().then(() => true);
          }
          return true;
        });

      case 'oidc':
        this.service = this.injector.get(AuthOidcService);
        return createOidc({
          issuerUri: `${env.keycloak!.url}/realms/${env.keycloak!.realm}`,
          clientId: env.keycloak!.clientId,
          BASE_URL: '/',
          scopes: ['openid', 'profile', 'email'],
        }).then(oidc => {
          (this.service as AuthOidcService).setup(oidc);
          return oidc.isUserLoggedIn;
        });

      default:
        this.service = this.injector.get(AuthCartoAfService);
        return Promise.resolve(true);
    }
  }
}
